const disclosures = {
    baseMsrp: {
        name: 'Base MSRP',
        order: 2,
        desc: `Excludes Destination and Delivery Charges, Taxes, Title, License Fees, and Dealer Installed Options.`
    },
    totalOfOptions: {
        name: 'Total of Options',
        order: 3,
        desc: `Vehicle add-ons that are included on the Manufacturer's Window Sticker/Monroney Sticker.`
    },
    destinationAndDelivery: {
        name: 'Destination & Delivery Charges',
        order: 4,
        desc: `Charges associated with getting the vehicle from the manufacturer to the Dealer.`
    },
    totalMsrp: {
        name: 'Total MSRP',
        order: 5,
        desc: `Base MSRP plus Total of Options, Destination and Delivery Charges. Excludes Taxes, Title, and License Fees.`
    },
    dealerAdjustments: {
        name: 'Dealer Adjustment',
        order: 6,
        desc: `Your Ford Dealer enters this amount as part of building your Dealer Selling Price. Your Dealer will also enter other amounts in the Dealer Selling Price details to complete the Dealer Selling Price. The amount is not a discount and does not represent a savings or the full difference between the Dealer Selling Price and Total MSRP.`
    },
    totalDealerInstalledOptions: {
        name: 'Dealer Installed Options',
        order: 10,
        desc: `Vehicle add-ons that are not included on the Manufacturer's Window Sticker/Monroney Sticker.`
    },
    dealerDiscount: {
        name: 'Dealer Discount',
        order: 8,
        desc: `Discount(s) offered by your Dealer.`
    },
    documentFee: {
        name: 'Documentation Fee',
        order: 9,
        desc: `This fee amount and name may vary by state. In certain states, the Dealer may charge a fee for services related to the sale/lease of the vehicle. See your Dealer for additional information.`
    },
    dealerSellingPrice: {
        name: 'Dealer Selling Price',
        order: 1,
        desc: `The price the Dealer is willing to sell the vehicle for in a purchase transaction. For lease, it is the agreed upon value of the vehicle. Excludes Current Available Incentives and Taxes and Fees Total.`
    },
    totalAXZPlanPricing: {
        name: 'AXZ Plan Pricing',
        order: 7,
        desc: `The Dealer Selling Price that is only available to AXZ Plan customers with a valid PIN. Excludes Dealer Installed Options, Current Available Incentives, Taxes and Fees Total, License, Title, and Registration Fees.`
    },
    grossAllowance: {
        name: 'Trade-In Value',
        order: 11,
        desc: `This amount will be validated by a physical inspection of the vehicle at the Dealer, which may affect the final value offered for trade-in. For existing lease customers, this amount is not applicable to your experience and will always be $0. Please see Trade-In Terms and Conditions for more details: <a href="https://www.tradein.ford.com/termsandconditions/US/en_us" target="_blank" rel="noopener noreferrer" >https://www.tradein.ford.com/termsandconditions/US/en_us.</a>`
    },
    payoffOwed: {
        name: 'Remaining Balance',
        order: 12,
        desc: `This is an amount owed for your trade-in vehicle as of the date/time provided by you or your lender in the Trade-In Program. If you are leasing your trade-in vehicle, this is called your “Lease Obligation to Terminate Amount.” Please see Trade-In Terms and Conditions for more details: <a href="https://www.tradein.ford.com/termsandconditions/US/en_us" target="_blank"  rel="noopener noreferrer">https://www.tradein.ford.com/termsandconditions/US/en_us.</a>`
    },
    netTradeInAllowance: {
        name: 'Net Trade-In',
        order: 13,
        desc: `This Net Trade-In Amount is the difference between the Trade-In Value and any Remaining Balance. This value can be positive or negative. Please see Trade-In Terms and Conditions for more details: <a href="https://www.tradein.ford.com/termsandconditions/US/en_us" target="_blank" rel="noopener noreferrer" >https://www.tradein.ford.com/termsandconditions/US/en_us.</a>`
    },
    totalCostOfAccessories: {
        name: 'Accessories',
        order: 14,
        desc: `The sale price for accessories, including all installation costs. Excludes taxes.`
    },
    insuranceWarranties: {
        name: 'Protection Plans',
        order: 15,
        desc: `Extended protection plans are optional and not required to purchase or obtain financing. Plan availability, benefits, and coverage may vary by state. Please carefully review each plan’s service contract for the actual terms and conditions, including a list of covered repairs, prior to purchase. See Dealer for service contract.`
    },
    preTaxPrice: {
        name: 'Your Pre-Tax Price',
        order: 38,
        desc: `Includes the Dealer Selling Price, any Down Payments, Reservation Deposits, Order Deposits, applicable Current Available Incentives, Net Trade-In Amount, Accessories, and Protection Plans.`
    },
    salesTax: {
        name: 'Taxes',
        order: 17,
        desc: `The Taxes applicable to the transaction of the vehicle based on information provided by your Dealer, zip code entered by you, and taxable price of the vehicle.`
    },
    licenseFee: {
        name: 'License',
        order: 18,
        desc: `The charge to License the vehicle. This information is provided by your dealer.`
    },
    titleFee: {
        name: 'Title',
        order: 19,
        desc: `The charge to Title the vehicle. This information is provided by your Dealer.`
    },
    registrationFee: {
        name: 'Registration',
        order: 20,
        desc: `The charge to Register the vehicle. This information is provided by your dealer.`
    },
    otherTaxesAndFees: {
        name: 'Other Taxes and Fees',
        order: 21,
        desc: `The sum of other charges, excluding those within Taxes, License, Title, Registration Fees, and Documentation Fee due at the time of vehicle purchase. This information is provided by your Dealer.`
    },
    totalTaxesAndFees: {
        name: 'Total Taxes and Fees',
        order: 16,
        desc: `The Taxes and Fees applicable to the transaction of the vehicle.`
    },
    grossCapCost: {
        name: 'Gross Capitalized Cost',
        order: 22,
        desc: `An estimate of the agreed upon value of the vehicle plus any items that you will pay over the lease term (such as service contracts, insurance, and any outstanding prior credit or lease balance).`
    },
    totalCapitalizedCostReduction: {
        name: 'Capitalized Cost Reduction',
        order: 23,
        desc: `The amount of any net trade-in allowance, rebate, noncash credit, or cash that you will pay to reduce the Gross Capitalized Cost.`
    },
    cashDownPayment: {
        name: 'Down Payment',
        order: 24,
        desc: `The cash amount paid towards the total down payment for the transaction, including your reservation and order deposit. For lease, this is the cash you pay to reduce the Gross Capitalized Cost.`
    },
    currentAvailableIncentives: {
        name: 'Available Incentives',
        order: 25,
        desc: `Incentives are available at the time of posting, determined by the zip code entered by the consumer, and subject to change and expiration. May not be available with some other offers. Restrictions may apply. See your Dealer for further details.`
    },
    adjustedCapCost: {
        name: 'Adjusted Capitalized Cost',
        order: 26,
        desc: `The amount used to determine the monthly lease payment. It represents the difference between Gross Capitalized Cost and Capitalized Cost Reduction.`
    },
    totalAmountsDueAtLeaseSigningOrDelivery: {
        name: 'Amounts Due At Lease Signing',
        order: 27,
        desc: `The amount to be paid by the lessee prior to or at the signing of the lease or by the delivery of the vehicle. It includes the first month’s payment and your Capitalized Cost Reduction.`
    },
    totalDueAtVehicleLicensingAgency: {
        name: 'Due at Vehicle Licensing Agency',
        order: 28,
        desc: `This is an estimate of the taxes and fees applicable to the sale of the vehicle. ACTUAL TAXES & FEES MAY VARY based on state and local laws and tax rates in effect at the time of purchase. See your Dealer for further details.`
    },
    basePayment: {
        name: 'Base Payment',
        order: 29,
        desc: `Your monthly payment before taxes.`
    },
    monthlyTax: {
        name: 'Monthly Tax',
        order: 30,
        desc: `This is an estimate of the monthly sales or use tax applicable to the payment of the vehicle based on information provided by your Dealer and zip code entered by you, or taxable price of the vehicle. ACTUAL TAXES MAY VARY based on state, local laws, and tax rates in effect at the time of purchase. See your Dealer for further details.`
    },
    monthlyPayment: {
        name: 'Monthly Payment',
        order: 31,
        desc: `<ol type="a" style="padding-inline-start: 24px;">
        <li><span style="font-weight: 700; font-style:italic">For Financing:</span> Payments are based on Amount Financed, APR, and Term selected.</li>
        <li><span style="font-weight: 700; font-style:italic">For Leasing:</span> Payments are based on Adjusted Capitalized Cost, Residual Value, Rent Charge, Term, and Annual Mileage selected.</li>
        </ol>`
    },
    monthlyPaymentsDue: {
        name: 'Monthly Payment 1-36 Months',
        order: 32,
        desc: `Lower payments for the first 36 months are based on Amount Financed, APR, Term, and Flexbuy payment discount.`
    },
    secondMonthlyPaymentsDue: {
        name: 'Monthly Payment 37-XX Months',
        order: 33,
        desc: `Higher payments starting at month 37 are based on remaining balance of Amount Financed, APR, and Term.`
    },
    annualMileage: {
        name: 'Annual Mileage',
        order: 34,
        desc: `The miles per year that you expect to drive should match the mileage allowance you select. The mileage allowance you select impacts the Monthly Payment and the terms of repayment. Lessee is responsible for Excess Wear and Use and for Mileage over the “miles per term allowance” as stated below:
        <ul style="list-style-type:disc;padding-inline-start: 24px;">
        <li>$0.15 per mile for vehicles with Base MSRPs up to $30,000</li>
        <li>$0.20 per mile for vehicles with Base MSRPs from $30,001 to $49,999</li>
        <li>$0.25 per mile for vehicles with Base MSRPs over $50,000</li></ul>`
    },
    term: {
        name: 'Term (Number of Months)',
        order: 35,
        desc: `The number of scheduled months in your contract.`
    },
    annualPercentageRate: {
        name: 'APR',
        order: 36,
        desc: `Annual Percentage Rate is the cost of your credit as a yearly rate.`
    },
    amountFinanced: {
        name: 'Amount Financed',
        order: 37,
        desc: `The amount of credit you are approved for, which is calculated by (1) the Dealer Selling Price (subtracting the Total Down Payment); and (2) adding any other amounts that are financed and are not part of the finance charge.`
    },
    currentAvailableIncentivesNonCash: {
        name: 'Available Incentives and Non-Cash Credits',
        order: 39,
        desc: `Incentives are available at the time of posting, determined by zip code entered by the consumer, and subject to change and expiration. May not be available with some other offers. Restrictions may apply. See your Dealer for further details. Non-Cash Credits is your total of Reservation and/or Order Deposit amounts you may have already paid to your Dealer at the time of a reservation and/or order. If you do not have a Reservation or Order Deposit, this amount only includes Available Incentives.`
    },
    cashDueAtDealer: {
        name: 'Cash Amount Due At Dealer',
        order: 40,
        desc: `The total cost of your purchase including your sum of Current Available Incentives, Order Deposit, Reservation Deposit, Net Trade-In Amount, Accessories, Charging, Protection Plans, and Taxes and Fees Total.`
    },
    vehicleImage: {
        name: 'Vehicle Image',
        order: 41,
        desc: `Vehicle image shown for illustration purposes only, actual vehicle may vary due to product configurations.`
    },
    residualAmount: {
        name: 'Residual Value',
        order: 42,
        desc: `The value of the vehicle at the end of the lease used in calculating your Base Payment.`
    },
    federalEVTaxCredit: {
        name: 'Federal EV Tax Credit',
        order: 43,
        desc: `Please consult with your own tax or legal professional to determine your individual eligibility. Tax credit amount is based on vehicle-specific component sourcing and assembly and may be subject to change. You may not claim the credit if (1) your adjusted gross income exceeds certain thresholds or (2) the MSRP of the vehicle, as configured, exceeds $80,000 (including all optional equipment attached to the vehicle at the time of delivery to the dealer, but excluding destination charges, optional items added by the dealer, taxes and fees). Tax credit may be applied at point of sale, subject to dealer availability, or as a potential future tax savings. The amount of your tax savings will depend on your individual tax circumstances. Incentives and additional rebates are not within Ford’s control. This information does not constitute tax or legal advice. For additional information, go to Federal Tax Credits for Plug-in Electric and Fuel Cell Electric Vehicles Purchased in 2023 or After .`
    }
}
export const getDisclosures = () => {
    return disclosures
}
